import { Icon, Card, Row } from '../cake-builder/ui'

const reasons = [
  { icon: <Icon.Leaf />, title: 'Fresh cream, always', sub: 'Every cake is fresh cream. Fondant only for fine details.' },
  { icon: <Icon.Star />, title: 'Your design, our hands', sub: 'Themes, toppers, photos. We build the cake you picture.' },
  { icon: <Icon.Tag />, title: 'Pickup or delivery', sub: 'Pick up in Hoofddorp, or get it delivered through the Kookxtra app.' },
]

function WhyChooseUs() {
  return (
    <section className="bg-white">
      <div className="container mx-auto px-4 py-8 md:py-16 max-w-3xl">
        <h2 className="text-[26px] md:text-4xl mb-4 md:mb-8 md:text-center">Why people come back</h2>
        <Card className="divide-y divide-gray-100">
          {reasons.map((r) => (
            <Row key={r.title} icon={r.icon} title={r.title} sub={r.sub} />
          ))}
        </Card>
      </div>
    </section>
  )
}

export default WhyChooseUs
